var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_title"},[_c('span',[_vm._v("\n  "+_vm._s(_vm.title)),_vm._t("left")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }